import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  itemTitle: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 18
  },
  itemSubtitle: {
    color: theme.palette.grey[600],
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular
  },
  itemDescription: {
    color: theme.palette.grey.black,
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular
  },
  itemContent: {
    padding: `${theme.spacing(0)} !important`
  },
  overlineLabel: {
    lineHeight: 2
  }
}));
